<div class="searchBox" [ngClass]="this.searchService.expanded ? 'expanded':''">
  <ng-autocomplete
    class="searchBox"
    [data]="options"
    [searchKeyword]="keyword"
    placeholder="Search"
    (selected)='selectEvent($event)'
    (inputChanged)='onChangeSearch($event)'
    (inputFocused)='onFocused($event)'
    historyIdentifier="countries"
    [itemTemplate]="itemTemplate"
    [notFoundTemplate]="notFoundTemplate"
    (click)="expandSearch()">
  </ng-autocomplete>

  <ng-template #itemTemplate let-item>
    <a [innerHTML]="item.name"></a>
  </ng-template>

  <ng-template #notFoundTemplate let-notFound>
    <div [innerHTML]="notFound"></div>
  </ng-template>
  <input hidden type="file" #fileElement (change)="fileExplorerCallBack($event.target.files[0])">
</div>
